/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Assessment from 'linced-admin/models/assessments/assessment';
import type GradeSchedule from 'linced-admin/models/assessments/grade-schedule';

// Proto: assessments.ModuleTemplate.
export default class Module extends Model {
  declare [Type]: 'assessments/module';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @attr('boolean', { defaultValue: false })
  declare isLocked: boolean;

  @belongsTo('assessments/assessment', { async: true, inverse: 'modules' })
  declare assessmentId: AsyncBelongsTo<Assessment>;

  @alias('assessmentId')
  declare assessment: AsyncBelongsTo<Assessment>;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number')
  declare type: number | undefined;

  @attr('string')
  declare key: string | undefined;

  @belongsTo('assessments/grade-schedule', { async: true, inverse: null })
  declare gradeScheduleId: AsyncBelongsTo<GradeSchedule>;

  @alias('gradeScheduleId')
  declare gradeSchedule: AsyncBelongsTo<GradeSchedule>;

  @attr('boolean', { defaultValue: false })
  declare isModerated: boolean;

  @attr('boolean', { defaultValue: false })
  declare sharesEvidence: boolean;

  @attr('number', { defaultValue: 0 })
  declare numericStepping: number;

  @attr('number', { defaultValue: 0 })
  declare dueTime: number;
}
